import { useState } from 'react';

import { AppModal } from '../AppModal';

export interface RejectModalProps {
  busy: boolean;
  error: string | null;
  /** reason is already capped at 500 by RejectIngestSchema; we hard-cap input too. */
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

// Reject-ONLY modal for the doc-ingest review route. The generic DecisionModal
// offers approve/return/reject lanes; here the only action is reject, so we
// render a thin standalone modal (reusing AppModal) with a single required
// reason textarea. Contract kept identical to the route's usage:
// { busy, error, onConfirm(reason), onClose }.
export function RejectModal({ busy, error, onConfirm, onClose }: RejectModalProps) {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const confirmDisabled = busy || !trimmed;

  function confirm() {
    if (confirmDisabled) return;
    // RejectIngestSchema caps reason at 500; hard-cap the client input too (#8).
    onConfirm(reason.slice(0, 500));
  }

  return (
    <AppModal
      title="ปฏิเสธเอกสาร"
      subtitle="ระบุเหตุผลในการปฏิเสธเอกสารนี้"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn ghost" onClick={onClose}>
            ยกเลิก
          </button>
          <button
            type="button"
            className="btn primary"
            disabled={confirmDisabled}
            style={{ background: 'var(--negative)' }}
            onClick={confirm}
          >
            {busy ? 'กำลังบันทึก…' : 'ยืนยันการปฏิเสธ'}
          </button>
        </>
      }
    >
      <label className="meta" style={{ display: 'block', marginBottom: 6 }}>
        เหตุผล *
      </label>
      <textarea
        className="input"
        rows={3}
        value={reason}
        maxLength={500}
        placeholder="เหตุผลที่ปฏิเสธเอกสาร"
        onChange={(e) => setReason(e.target.value)}
        style={{ width: '100%', resize: 'vertical', padding: 8 }}
      />
      {error && <div style={{ color: 'var(--negative)', fontSize: 14, marginTop: 8 }}>{error}</div>}
    </AppModal>
  );
}
